import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NotifierService } from 'angular-notifier';
import { StudySurveyService } from '../study-survey.service';

@Component({
  selector: "app-survey-dialog-box",
  templateUrl: "./survey-dialog-box.component.html",
  styleUrls: ["./survey-dialog-box.component.scss"],
})
export class SurveyDialogBoxComponent implements OnInit {
  public type: string = null;
  public errorMsg: string = '';
  inputData: FormGroup;
  constructor(
    public dialoge: MatDialog,
    public notifier: NotifierService,
    private studyService: StudySurveyService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit(): void {
    this.inputData = new FormGroup({
      'share' : new FormGroup({
        'email': new FormControl(null, [Validators.required, Validators.email])
      }),
      'preview' : new FormGroup({
        'number': new FormControl(null, [Validators.required]),
        'sms': new FormControl(true),
        'whatsapp': new FormControl(true)
      })
    })
    this.type = this.data.type;
  }

  isFormValid() {
    if(this.type == 'share') {
      if(!this.inputData.get('share.email').valid) {
        this.errorMsg = 'Please Enter Valid Email';
        return false;
      }
    } else {
      if(!this.inputData.get('preview.number').valid) {
        this.errorMsg = 'Please Enter a Valid Phone Number';
        return false;
      }
      if(!this.inputData.get('preview.sms').value && !this.inputData.get('preview.whatsapp').value) {
        this.errorMsg = 'Please check atleast one Channel to share link';
        return false;
      }
    }
    this.errorMsg = '';
    return true;
  }

  onSubmit() {
    if(this.isFormValid()) {
      let data = {};
      // data['uuid'] = this.studyService.surveyUUID;
      data['id'] = this.studyService.surveyUUID;
      data['link'] = this.studyService.universalSurveyUrl;
      // data['link'] = window.location.href;
      data['share'] = [];
      let typeObj = {};
      let action = '';

      if(this.type == 'share') {
        typeObj['type'] = 'mail';
        typeObj['email'] = this.inputData.get('share.email').value;
        action = "Survey Shared on Email";
      } else if(this.type == 'mobile-preview') {
        let isSms = this.inputData.get('preview.sms').value;
        let isWhatsapp = this.inputData.get('preview.whatsapp').value;

        typeObj['phone'] = this.inputData.get('preview.number').value;

        if(isSms && isWhatsapp) {
          data['share'].push({type:'sms',phone:typeObj['phone']});
          typeObj['type'] = 'whatsapp';
          action = "Survey Shared on SMS and Whatsapp both";
        } else if(isSms && !isWhatsapp){
          typeObj['type'] = 'sms';
          action = "Survey Shared via SMS";
        }
        else if(!isSms && isWhatsapp){
          typeObj['type'] = 'whatsapp';
          action = "Survey Shared via Whatsapp";
        }
      }

      data['share'].push(typeObj);
      this.studyService.sendSurveyGAEvent("EagleInsights-survey-preview-share",{event_action: action});
      this.studyService.shareSurvey(data);

    } else this.notifier.notify('error',this.errorMsg);
  }
}
